import React from "react";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import { DA_Container } from "@danishagro/shared/src/components/atoms/Container/Container.component";
import { DA_Text } from "@danishagro/shared/src/components/atoms/Text/Text.component";
import {
    DA_Title,
    DA_TitleTag,
} from "@danishagro/shared/src/components/atoms/Title/Title.component";
import { SSH_Buttons } from "../../../../components/molecules/Buttons/Buttons.component";
import { SSH_ImageViewer } from "../../../../components/molecules/ImageViewer/ImageViewer.component";
import { useBackgroundColor } from "../../../../hooks/useBackgroundColor/useBackgroundColor.hook";
import { usePadding } from "../../../../hooks/usePadding/usePadding.hook";
import { SSH_AuthorBlock } from "../../../../components/organisms/AuthorBlock/AuthorBlock.component";
import { useDropdownImageSize } from "../../../../hooks/useDropdownImageSize/useDropdownImageSize.hook";
import useFormattedCultureDate from "../../../../hooks/useFormattedCultureDate.hook";
import { V1Props } from "./TextImageV1.interface";
import { useImageSize } from "./hooks/useImageSize.hook";
import { usePosition } from "./hooks/usePosition.hook";
// eslint-disable-next-line css-modules/no-unused-class
import S from "./TextImageV1.module.scss";

const V1 = (props: V1Props) => {
    const { positionClass } = usePosition(props.position, S);
    const { imageSizeClass } = useImageSize(props.imageSize, S);
    const { imageDropdownSizeClass } = useDropdownImageSize(props.dropdownImageSize, S);
    const { backgroundColorClass, alternativeButtonTheme, hasBackgroundColor } = useBackgroundColor(
        props.backgroundColor
    );

    const { paddingClass } = usePadding(props.isCompact, hasBackgroundColor);

    //use dateCulture from Umbraco global settings
    const date = useFormattedCultureDate(props?.date);

    return (
        <div
            className={cn(
                S.wrapper,
                backgroundColorClass,
                imageSizeClass,
                imageDropdownSizeClass,
                paddingClass,
                positionClass
            )}
        >
            <DA_Container noVerticalPadding>
                <div className={S.inner}>
                    {/** Content */}
                    <div className={S.textWrapper}>
                        {/** Author */}
                        {(props?.authorImageUrl || props?.authorName) && (
                            <SSH_AuthorBlock
                                authorImageUrl={props?.authorImageUrl}
                                authorImageName={props?.authorImageName}
                                authorName={props?.authorName}
                                authorTitle={props?.authorTitle}
                                authorDate={date}
                            />
                        )}

                        {/** Tagline */}
                        {props?.tagline ? (
                            <span className={S.tagline}>{props?.tagline}</span>
                        ) : null}

                        {/** Title */}
                        {props?.headline ? (
                            <DA_Title h2 tag={DA_TitleTag.H2} noMargin fullWidth>
                                {props?.headline}
                            </DA_Title>
                        ) : null}

                        {/** Text */}
                        {props?.text ? (
                            <div className={S.text}>
                                <DA_Text html={props?.text} noPadding />
                            </div>
                        ) : null}

                        {/** Buttons */}
                        <SSH_Buttons buttons={props?.buttons} theme={alternativeButtonTheme} />
                    </div>

                    {/** Image */}
                    {props?.image ? (
                        <div className={S.imageWrapper}>
                            <div className={S.imageInner}>
                                <SSH_ImageViewer
                                    src={props?.image.url}
                                    aspectRatioX={props?.image.width}
                                    aspectRatioY={props?.image.height}
                                    alternative={props?.image.alternative}
                                    naturalSize={!props?.image.width || !props?.image.height}
                                />

                                {/** Caption */}
                                {props?.image.caption ? (
                                    <div className={S.caption}>{props?.image.caption}</div>
                                ) : null}
                            </div>
                        </div>
                    ) : null}
                </div>
            </DA_Container>
        </div>
    );
};

export default V1;
